import EntranceM from './images/backdrops/entranceP.jpg'
import Countdown from './images/backdrops/entrance.jpg'
import CountdownM from './images/backdrops/countdownM.png'
import LobbyL from './images/backdrops/lobby.jpg'
import LobbyM from './images/backdrops/space.jpg'
import Exhibition from './images/backdrops/exhibition.jpg'
import Auditorium from './images/backdrops/auditorium.jpg'
import AuditoriumM from './images/backdrops/space.jpg'
import MC from './images/backdrops/MC20.png'
import NetworkingL from './images/backdrops/networking.jpg'
import NetworkingM from './images/backdrops/networkingM.jpg'
import LobbyMusic from './images/audio/lobby.mp3'
import routes from './routes'
import Gallerium from './images/backdrops/gallerium.jpg'
import infoIcon from './images/dark-info.png'
import closeLeftGlassDoor from './images/backdrops/glass_closedoor_left.png'
import openLeftGlassDoor from './images/backdrops/glass_opendoor_left.png'
import closeRightGlassDoor from './images/backdrops/glass_closedoor_right.png'
import openRightGlassDoor from './images/backdrops/glass_opendoor_right.png'
import closeLeftWoodDoor from './images/backdrops/wood_closedoor_left.png'
import openLeftWoodDoor from './images/backdrops/wood_opendoor_left.png'
import closeRightWoodDoor from './images/backdrops/wood_closedoor_right.png'
import openRightWoodDoor from './images/backdrops/wood_opendoor_right.png'

const dev = {
  apiUrl: 'http://localhost:3000',
  // apiUrl: 'https://moaasm.com',
}

const prod = {
  apiUrl: 'https://2021.moaasm.com',
}

const API_KEYS = {
  amplitude: '75561b40975373d37f4bf4a661e0391e',
}

const VOLUME_VALUE = 0

const config = process.env.NODE_ENV === 'production' ? prod : dev

const assets = {
  entrance: {
    landscape: Countdown,
    portrait: EntranceM,
  },
  countdown: {
    landscape: Countdown,
    portrait: CountdownM,
  },
  lobby: {
    landscape: LobbyL,
    portrait: LobbyM,
  },
  auditorium1: {
    landscape: Auditorium,
    portrait: AuditoriumM,
  },
  auditorium2: MC,

  exhibition1: Exhibition,
  exhibition2: Exhibition,

  networking: {
    landscape: NetworkingL,
    portrait: NetworkingM,
  },
  gallerium: Gallerium,

  lobbyMusic: LobbyMusic,

}

const layout = {
  auditoriumVid: `
    top: 20%;
    bottom: 28%;
    left: 15%;
    right: 34%;
  `,
}

const lobbyEntries = [
  {
    id: 'auditorium',
    destination: [
      { name: 'Lecture Hall A', url: routes.auditorium1 },
      { name: 'Lecture Hall B', url: routes.auditorium2 },
    ],
    entryOpenImage: openLeftWoodDoor,
    entryCloseImage: closeLeftWoodDoor,
    css: `
      top: 56.8%;
      left: 33.5%;
      right: 59%;
      bottom: 35%;
    `,
  },
  {
    id: 'exhibition',
    destination: [
      { name: 'Hall A', url: routes.exhibition1 },
      { name: 'Hall B', url: routes.exhibition2 },
      { name: 'Hall C', url: routes.exhibition3 },
    ],
    entryOpenImage: openRightWoodDoor,
    entryCloseImage: closeRightWoodDoor,
    css: `
      top: 56.8%;
      left: 61.5%;
      right: 31%;
      bottom: 35%;
    `,
  },
  {
    id: 'networking',
    destination: routes.networking,
    entryOpenImage: openLeftGlassDoor,
    entryCloseImage: closeLeftGlassDoor,
    css: `
      top: 29.5%;
      left: 27.7%;
      right: 64.6%;
      bottom: 63.8%;
    `,
  },
  {
    id: 'gallerium',
    destination: routes.onDemand,
    entryOpenImage: openRightGlassDoor,
    entryCloseImage: closeRightGlassDoor,
    css: `
      top: 29.5%;
      left: 66.4%;
      right: 26%;
      bottom: 63.8%;
    `,
  },
  {
    id: 'helpdesk',
    destination: 0,
    infoImage: infoIcon,
    css: `
      top: 72%;
      left: 32%;
      right: 86%;
      bottom: 40.5%;
    `,
  },
]

export default {
  API_KEYS,
  assets,
  layout,
  lobbyEntries,
  VOLUME_VALUE,

  eventName: '50th MOA ASM incorporating the 40th AOA 2021 Virtual Conference',

  ...config,
}
